// 匿名 ID:按用户持久化的 8 位随机串,用于泄露溯源(不直接暴露真实 user id)
const STORAGE_KEY = 'cloakchat_anon_map';

export function anonIdOf(userId: number | string): string {
  const uid = String(userId);
  let map: Record<string, string> = {};
  try {
    map = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    /* ignore */
  }
  if (!map[uid]) {
    map[uid] = Math.random().toString(36).slice(2, 10);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
      /* ignore */
    }
  }
  return map[uid];
}
